import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function RegisterPage() {
  const location = useLocation();
  const redirectTo = location.state?.from || '/';
  const [form, setForm] = useState({ email: '', password: '', display_name: '', phone: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const update = (field) => (e) => setForm(f => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    setLoading(true);
    try {
      await register(form.email, form.password, form.display_name, form.phone || undefined);
      navigate(redirectTo, { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <img src="/logo.svg" alt="Emotional Intelligence" style={{ width: 80, height: 80, margin: '0 auto 16px', display: 'block' }} />
        <h1>Join the listening room</h1>
        <p className="subtitle">Create your account to start voting</p>
        {error && <div className="error-msg">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Display Name</label>
            <input className="input" value={form.display_name}
              onChange={update('display_name')} required placeholder="How others will see you" />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input className="input" type="email" value={form.email}
              onChange={update('email')} required />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input className="input" type="password" value={form.password}
              onChange={update('password')} required minLength={6} />
          </div>
          <div className="form-group">
            <label>Phone Number <span className="text-secondary">(optional, for SMS notifications)</span></label>
            <input className="input" type="tel" value={form.phone}
              onChange={update('phone')} placeholder="+1 (555) 123-4567" />
          </div>
          <button className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>
        <p className="mt-16 text-sm text-secondary" style={{ textAlign: 'center' }}>
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
